import { Box } from "@mui/material";

import AuthBrandPanel from "./AuthBrandPanel";

export default function AuthShell({
  children,
  brandTitle,
  brandDescription,
  formMaxWidth = 330,
  minHeight = "100vh",
  showIntegrations = true,
}) {
  return (
    <Box
      sx={(theme) => ({
        bgcolor: theme.palette.surface.default,
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "minmax(430px, 1fr) minmax(420px, 1fr)",
        },
        minHeight,
        overflowX: "hidden",
        width: "100%",
      })}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: { xs: "flex-start", sm: "center" },
          minHeight,
          minWidth: 0,
          overflowY: "auto",
          px: { xs: 2, sm: 4, md: 5, lg: 7, xl: 8 },
          py: { xs: 4, sm: 5, md: 6 },
          width: "100%",
          "@media (max-height: 800px)": {
            py: { xs: 3, sm: 4, md: 3 },
          },
          "@media (max-height: 680px)": {
            justifyContent: "flex-start",
          },
        }}
      >
        <Box
          sx={{
            maxWidth: {
              xs: "min(326px, calc(100vw - 32px))",
              sm: formMaxWidth,
            },
            minWidth: 0,
            width: "100%",
          }}
        >
          {children}
        </Box>
      </Box>

      <AuthBrandPanel
        title={brandTitle}
        description={brandDescription}
        minHeight={minHeight}
        showIntegrations={showIntegrations}
      />
    </Box>
  );
}
